
Element.prototype.unsubForm = () => {
    
    const testRegex = (r) => (x) => r.test(x);
    jQuery.validator.addMethod('validEmail', testRegex(/^(([0-9a-zA-Z])+([-._'+&]))*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$/));
    const hcp = jQuery('input#edit-user-type-hcp');
    const consumer = jQuery('input#edit-user-type-consumer');
    const mobile = document.querySelector('input#edit-mobile-phone-number');
    jQuery('.f-Form_Unsubscribe').validate({
        rules: {
            email_address: {
                required: {
                    depends: function () {
                        if ( hcp.prop('checked') == true ) {
                            return true;
                        } else if (mobile.value == '' && consumer.prop('checked') == true  ) {
                            return true;
                        } else {
                           
                            jQuery('input#edit-email-address').rules("remove", "require");
                            return false;
                            
                        }
                    }
                },
                //validEmail: true,
                maxlength: 75,
            },
            user_type: "required",
            "types_of_communication[general]": {
                required: "#edit-user-type-consumer:checked"
            },
            "type_of_communication_hcp[ALL]": {
                required: '#edit-user-type-hcp:checked'
            },
            mobile_phone_number: {
                required: function(){
                    if ( !jQuery('input#edit-email-address').hasClass('valid') ) {
                        return true;
                    } else {
                        return false;
                    }
                },
                maxlength: 12,
                phoneUS: true,
            }
        },
        messages: {
            email_address: {
                "required": "Please provide your email address.",
                "validEmail": "Please input a valid email address.",
            },
            user_type: "Please confirm if you are a patient, caregiver, or healthcare professional.",
            "types_of_communication[general]": "Please select the type of email communications to unsubscribe from.",
            "type_of_communication_hcp[ALL]": "Please select the type of email communications to unsubscribe from.",
            mobile_phone_number: {
                'required': "Please specify a valid phone number.",
            }
        },
        errorPlacement: function (error, element) {
            let wrapper;
            if (element[0].name === 'user_type') {
                wrapper = element.closest("fieldset")
            } else if (element[0].name === 'types_of_communication[general]' || element[0].name === 'type_of_communication_hcp[ALL]') {
                wrapper = element.closest(".fieldset-wrapper")
            } else {
                wrapper = element.closest("fieldset, div.form-item")
            }
            console.log(element, wrapper)
            error.appendTo(wrapper);
        },
        errorClass: 'f-Form_Error'  
    });
    jQuery('input#edit-email-address').on('blur', function () {
        if (jQuery(this).hasClass('valid')) {
            jQuery('input#edit-mobile-phone-number').removeClass('f-Form_Error');
        jQuery('label#edit-mobile-phone-number-error').remove();
        }
    });
    jQuery('input#edit-mobile-phone-number').on('blur', function () {
        if (jQuery(this).hasClass('valid')) {
            jQuery('input#edit-email-address').removeClass('f-Form_Error');
        jQuery('label#edit-email-address-error').remove();
        }
    });
    jQuery('#edit-mobile-phone-number').keyup(function(){
        jQuery(this).val(jQuery(this).val().replace(/(\d{3})\-?(\d{3})\-?(\d{4})/, '$1-$2-$3'));
    });


}

// Only run the function whenever there is an instance of a Eligibility Tool
if ( document.querySelector('.f-Form_Unsubscribe') ) {
    document.querySelector('.f-Form_Unsubscribe').unsubForm();
}






